import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { UserBookingResponse } from 'app/typings/core/admin/users/userBooking';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useUserBookings(userId: number) {
  return useQuery({
    queryKey: [CORE_QUERY_KEYS.user, { id: userId }],
    queryFn: userId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getUserBookings,
            params: { id: userId.toString() },
          }) as Promise<UserBookingResponse[]>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!userId,
  });
}
